import { Grid } from 'jrgrid';
import React, { Fragment } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Loader } from '../../../components/Loader';
import Navbar from '../../../components/Navbar';
import { FilterButtons } from '../../Receiving/utils';
import { pageSalvage } from '../api';
import { salvageColumns } from '../utils';

export const SalvageItems = (props: any) => {
  const [refresh, setRefresh] = React.useState(false);
  const [itAdmin, setItAdmin] = React.useState(false);
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));
  const [gridFilter, setGridFilter] = React.useState([])
  //   {
  //     id: 'toDeptId',
  //     type: 'number',
  //     operand: 'and',
  //     isLike: false,
  //     value: `${user.currentRole.departmentId}`,
  //   },
  // ]);

  const salvageFilterButtons = [
    new FilterButtons('Pending Disposal', 'info', {
      id: 'updateStatus',
      type: 'string',
      operand: 'and',
      isLike: true,
      value: '%disposal%',
    }),
    new FilterButtons('Pending PC&A', 'info', {
      id: 'updateStatus',
      type: 'string',
      operand: 'and',
      isLike: true,
      value: '%pc%',
    }),
    // new FilterButtons('Pending PSM', 'info', {
    //   id: 'updateStatus',
    //   type: 'string',
    //   operand: 'and',
    //   isLike: true,
    //   value: '%psm%',
    // }),
    // new FilterButtons('Pending MA', 'info', {
    //   id: 'updateStatus',
    //   type: 'string',
    //   operand: 'and',
    //   isLike: true,
    //   value: '%ma%',
    // }),
    new FilterButtons('Salvage Complete', 'info', {
      id: 'updateStatus',
      type: 'string',
      operand: 'and',
      isLike: true,
      value: '%approved%',
    }),
    new FilterButtons('Show All', 'info', {
      id: 'updateStatus',
      type: 'string',
      operand: 'and',
      isLike: true,
      value: '',
    }),
  ];

  React.useEffect(() => {
    let admin = false;
    user.roles.forEach((role) => {
      if (role.isAdmin) admin = true;
    });
    setItAdmin(user.currentRole.departmentId === 19 || admin);
  }, []);

  const renderGrid = () => {
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid...' />;
    } else {

      let filter = []

      
      return (
        <Grid
          amount={15}
          columns={salvageColumns}
          query={pageSalvage}
          queryName='pageSalvage'
          defaultSortField='salvageId'
          globalFilters={gridFilter ? [...gridFilter, ...filter] : [...filter]}
          refresh
          csv={user.currentRole.isAdmin}
        />
      );
    }
  };
  return (
    <Fragment>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <Col md={9}>
            {salvageFilterButtons.map((item, index) => {
              return(
                <Button
                key={index}
                className='mt-3 mb-3 ml-2'
                onClick={() => {
                  setGridFilter([item.filter])
                }}>
                  {item.title}
                </Button>
              )
            })}
          </Col>
          <Col md={3}>
            <h3 className='mt-3 mb-3 ml-2 mr-2 float-right '>Salvages</h3>
          </Col>
        </Row>
        <div className='ml-2 mr-2'>{renderGrid()}</div>
      </div>
    </Fragment>
  );
};
